
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-066d9ec6!sass-loader?data=@import \"~assets/styles/base\";@import \"~assets/styles/variables\";@import \"~assets/styles/mixins\";&sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewSong.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewSong.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-066d9ec6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewSong.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/NewSong.vue
// module id = 303
// module chunks = 2